import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MSALConfig } from "auth/microsoft";
import { GlobalAlert } from "components";
import CommonDialog from "components/molecules/CommonDialog";
import { TimeHelper } from "helpers";
import "moment/locale/vi";
import { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { RootReducer } from "redux/configurations/rootReducer";
import AppRouter from "routers";
import "utils/i18n/index";

const App = () => {
  const language = useSelector(
    (state: RootReducer) => state.LanguageReducer.language
  );

  useEffect(() => {
    TimeHelper.viInstallation();
  }, []);

  return (
    <BrowserRouter>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale={language} >
        <HelmetProvider>
          <Helmet titleTemplate="%s - MSD" defaultTitle="MSD WMS">
            <meta name="description" content="Powered by SCSSolutions" />
          </Helmet>
        </HelmetProvider>
        <AppRouter />
        <GlobalAlert />
        <CommonDialog />
      </LocalizationProvider>
    </BrowserRouter>
  );
};
export default App;
